import React from 'react';
import { useNavigate } from 'react-router-dom';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
  border: none;
  font: normal normal bold 14px/23px Source Sans Pro;
  color: #777777;
  text-transform: uppercase;

  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 18px;
  width: 47px;

  cursor: pointer;
`;

function ButtonBack({ previousPage, cb }) {
  const navigate = useNavigate();

  const goBackToPage = () => {
    navigate(`${previousPage}`);
  };

  return (
    <Button onClick={cb || goBackToPage}>
      <ArrowBackIosIcon />
      Voltar
    </Button>
  );
}

export default ButtonBack;

ButtonBack.propTypes = {
  previousPage: PropTypes.string.isRequired,
};
